type EventType = string;
type CustomEventListener<D = undefined> = (event: CustomEvent<D>) => void;

export class EventBus {
  static on<T extends EventType, D = undefined>(eventType: T, listener: CustomEventListener<D>) {
    document.addEventListener(eventType, listener as any);
  }

  static off<T extends EventType, D = undefined>(eventType: T, listener: CustomEventListener<D>) {
    document.removeEventListener(eventType, listener as any);
  }

  static once<T extends EventType, D = undefined>(eventType: T, listener: CustomEventListener<D>) {
    EventBus.on(eventType, handleEventOnce);

    function handleEventOnce(event: CustomEvent<D>) {
      listener(event);
      EventBus.off(eventType, handleEventOnce);
    }
  }

  static trigger<T extends EventType, D = undefined>(eventType: T, data: D) {
    const event = new CustomEvent<D>(eventType, { detail: data });
    document.dispatchEvent(event);
  }
}
